import { createComponent } from '@carvana/merch-components';

export const SectionContainer = createComponent('div', {
  className: 'flex flex-col gap-y-2xl lg:px-4xl'
});

export const SectionTitle = createComponent('h2', {
  className:
    'px-2xl py-sm text-text-strong t-heading-lg sm:px-3xl md:t-heading-xl lg:px-0'
});

export const TileContainer = createComponent('div', {
  className:
    'group/tile flex h-[242px] w-[220px] flex-col items-start rounded-lg bg-background-weak'
});

export const TextContainer = createComponent('div', {
  className: 'flex flex-col gap-y-xs px-xl pt-xl'
});

export const BrandText = createComponent('p', {
  className: 'text-text-default t-body-sm'
});

export const ModelText = createComponent('p', {
  className:
    'text-text-strong transition-colors t-heading-sm group-hover/tile:text-text-strong-active'
});

export const ModelImage = createComponent('img', {
  className: 'w-full'
});
